import { CLEAR_ALL_FIELDS, SET_SECTION_FIELDS } from "../constant"

export const setSectionFields = (key, data) => {
    return {
        type: SET_SECTION_FIELDS,
        payload: {
            section: key,
            data: data
        }
    }
}

export const clearAllFields = () => {
    return {
        type: CLEAR_ALL_FIELDS
    }
}